// @ts-nocheck
import { YStack, XStack, Text, Paragraph } from 'tamagui';
import { Container } from '../components/Container';
import { PageLayout } from '../components/PageLayout';
import { useIsMobile } from '../hooks/useIsMobile';

const productColors = {
  'Torch': '#34d399',
  'Statio': '#a03030',
  'Denarius': '#60a5fa',
  'JanusLedger': '#a78bfa',
  'Pilum': '#fb923c',
  'platform-core': '#71717a',
  'Romans.dev': '#a03030',
};

const changelog = [
  {
    month: 'March 2026',
    entries: [
      {
        product: 'Torch',
        version: 'v0.2.0',
        date: 'March 15, 2026',
        description: 'Beta launch with 50+ integrations, built-in productivity suite including Kanban, Sprints, OKRs, Calendar, Notes, Documents, and Wiki.',
      },
      {
        product: 'Statio',
        version: 'v0.2.0',
        date: 'March 10, 2026',
        description: 'Alpha launch with MCP Gateway, credential vaulting, access policies, and audit logging for AI agent API calls.',
      },
      {
        product: 'Pilum',
        version: 'v2.4',
        date: 'March 5, 2026',
        description: 'Added Cloudflare Pages as a deploy target. Improved parallel execution for monorepo workflows.',
      },
      {
        product: 'Romans.dev',
        version: '',
        date: 'March 1, 2026',
        description: 'Company website launched with product pages, waitlist signup, and the about page.',
      },
    ],
  },
  {
    month: 'February 2026',
    entries: [
      {
        product: 'Torch',
        version: 'v0.1.0',
        date: 'February 20, 2026',
        description: 'Initial alpha release with core search functionality and Gmail and Slack integrations.',
      },
      {
        product: 'Statio',
        version: 'v0.1.0',
        date: 'February 15, 2026',
        description: 'Prototype release with JWT-authenticated gateway and basic rate limiting.',
      },
      {
        product: 'platform-core',
        version: '',
        date: 'February 10, 2026',
        description: 'Auth, billing, organizations, teams, and permissions system launched. Go and TypeScript SDKs generated for all products.',
      },
    ],
  },
];

function ChangelogEntry({ entry, isMobile }) {
  const color = productColors[entry.product] || '#a03030';

  return (
    <YStack
      gap="$2"
      paddingVertical="$4"
      paddingHorizontal="$4"
      borderRadius="$3"
      borderWidth={1}
      borderColor="$color3"
      hoverStyle={{ borderColor: '$color5' }}
      style={{ transition: 'border-color 0.15s' }}
    >
      <XStack
        flexDirection={isMobile ? 'column' : 'row'}
        justifyContent="space-between"
        alignItems={isMobile ? 'flex-start' : 'center'}
        gap="$2"
      >
        <XStack flexDirection="row" alignItems="center" gap="$2" flexWrap="wrap">
          <Text
            fontSize="$4"
            fontWeight="700"
            color={color}
          >
            {entry.product}
          </Text>
          {entry.version && (
            <Text
              fontSize="$2"
              color="$color7"
              backgroundColor="$color3"
              paddingHorizontal="$2"
              paddingVertical={2}
              borderRadius="$2"
              fontFamily="$mono"
            >
              {entry.version}
            </Text>
          )}
        </XStack>
        <Text fontSize="$2" color="$color6">
          {entry.date}
        </Text>
      </XStack>
      <Paragraph fontSize="$3" color="$color9" lineHeight={22}>
        {entry.description}
      </Paragraph>
    </YStack>
  );
}

export default function ChangelogPage({ theme, toggleTheme }) {
  const isMobile = useIsMobile();

  return (
    <PageLayout theme={theme} toggleTheme={toggleTheme}>
      <Container>
        <YStack paddingVertical="$8" gap="$8" maxWidth={700}>
          {/* Header */}
          <YStack gap="$4">
            <Text fontSize="$2" color="$color6" textTransform="uppercase" letterSpacing={3} fontWeight="500">
              Updates
            </Text>
            <Text fontSize={40} fontWeight="700" color="$color12" lineHeight={48}>
              Changelog
            </Text>
            <Text fontSize="$3" color="$color7">
              What's new across all Romans products.
            </Text>
          </YStack>

          {/* Changelog entries grouped by month */}
          {changelog.map((group) => (
            <YStack key={group.month} gap="$4">
              <Text
                fontSize="$5"
                fontWeight="600"
                color="$color11"
                paddingBottom="$2"
                borderBottomWidth={1}
                borderBottomColor="$color4"
              >
                {group.month}
              </Text>
              <YStack gap="$3">
                {group.entries.map((entry, i) => (
                  <ChangelogEntry key={`${entry.product}-${i}`} entry={entry} isMobile={isMobile} />
                ))}
              </YStack>
            </YStack>
          ))}
        </YStack>
      </Container>
    </PageLayout>
  );
}
